module.exports = __webpack_public_path__ + "img/10.f95b37fb.jpg";